import { CCUtils } from "../../../../common/CCUtils"
import { Align } from "../../../../common/TextUtils"
import { ActivityKey } from "../../../../shared/models/ActivityKey"
import { ButtonContainer, Buttons } from "../../../generic-sprites/Buttons"
import { Rectangle } from "../../../generic-sprites/Shape"
import { Audio } from "../../../utils/Audio"
import { CameraZoom } from "../../../utils/CameraZoom"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { Transitions } from "../../transitions/Transitions"
import { EveryCigImages, everyCigMoviePreviewImage, EveryCigPart2Audio } from "../EveryCigAssets"
import { EveryCigStore } from "../EveryCigStore"
import { EveryCigBodyPart } from "../EveryCigTypes"
import { EveryCigDropdownScreenContainer } from "./EveryCigDropdownScreenContainer"
import { EveryCigMovieContainer } from "./EveryCigMovieContainer"


export class EveryCigViewVotesScreenOptionContainer {
    options: Array<EveryCigVoteScreenOption>
    nextButton: ButtonContainer

    static display = (
        game: Phaser.Game,
        group: Phaser.Group,
        x: number,
        y: number
    ) => new EveryCigViewVotesScreenOptionContainer(game, group, x, y)

    private constructor(
        private game: Phaser.Game,
        private group: Phaser.Group,
        x: number,
        y: number,
        private voteTotals?: Map<string, number>,
        private readonly topVoted?: string
    ) {
        PhaserText.create(game, "Vote for the \"Grossest\" Video", {
            x: Scale.x(0.559),
            y: Scale.y(0.008),
            group,
            fontPx: 20,
            debug: true,
            weight: "bold",
            align: Align.CENTER
        })
        this.nextButton = Buttons.create(game, "Next", this.clickNext, {
            scale: 0.5,
            x: Scale.x(0.839),
            y: Scale.y(0.395),
            debug: true,
            group
        })
        this.nextButton.disable()

        let currentX = x
        let currentY = y
        this.voteTotals = EveryCigStore.getVoteTotals()
        this.options = CCUtils.enumValues(EveryCigBodyPart).map((part: EveryCigBodyPart, index: number) => {
            const option = new EveryCigVoteScreenOption(game, part, this.voteTotals.get(part), group, currentX, currentY)
            if (index === 1) {
                currentY += option.option.height + option.title.height + Scale.y(0.002)
                currentX = x
            } else {
                currentX += option.option.width + Scale.x(0.01)
            }
            return option
        })

        this.topVoted = EveryCigStore.getTopVoted()
        let skullnbonesX
        let skullnbonesY
        switch (this.topVoted) {
            case EveryCigBodyPart.BRAIN:
                skullnbonesX = .593
                skullnbonesY = .069
                break
            case EveryCigBodyPart.EYE:
                skullnbonesX = .764
                skullnbonesY = .069
                break
            case EveryCigBodyPart.HEART:
                skullnbonesX = .593
                skullnbonesY = .224
                break
            case EveryCigBodyPart.LUNGS:
                skullnbonesX = .764
                skullnbonesY = .225
                break
            default:
                throw new Error("Unexpected body part for displaying Skull and Crossbones.")
        }
        // TODO: Replace this with a skull and crossbones image
        Sprites.add(this.game, EveryCigImages.SKULLNBONES, {
            scale: .15,
            x: Scale.x(skullnbonesX),
            y: Scale.y(skullnbonesY)
        })

        if (!EveryCigStore.instance.viewVotesAudio) {
            Audio.add(this.game, EveryCigPart2Audio.SEE_VOTES_PT2, {
                onPlay: () => {
                    this.nextButton.disable()
                    this.options.forEach(option => option.disable())
                },
                onStop: () => {
                    this.nextButton.enable()
                    this.options.forEach(option => option.enable())
                    EveryCigStore.instance.viewVotesAudio = true
                }
            })
        }

    }

    private clickNext = () => {
        CameraZoom.resetZoom(this.game)
        this.group.destroy(true)
        Transitions.startOutro(this.game, ActivityKey.EVERY_CIG_2)
    }

}

class EveryCigVoteScreenOption {
    option: Phaser.Sprite
    title: Phaser.Text
    private frame: Rectangle

    constructor(
        private game: Phaser.Game,
        public part: EveryCigBodyPart,
        private voteTotal: number,
        private group: Phaser.Group,
        x: number,
        y: number
    ) {
        this.option = Sprites.add(game, everyCigMoviePreviewImage(part), {group, debug: true, x, y, scale: 0.1})
        this.frame = new Rectangle(game, this.option.x, this.option.y, this.option.width, this.option.height, {
            group,
            lineColor: Phaser.Color.RED,
            lineWidth: 4
        })
        this.frame.graphics.alpha = 0
        this.title = PhaserText.create(game, voteTotal.toString(10), {group, weight: "bold", align: Align.CENTER, fontPx: 12})
        Sprites.centerTextInSprite(this.option, this.title)
        this.title.y += (this.option.height / 2) + Scale.y(0.02)
        this.enable()
    }

    enable = () => Buttons.makeSpriteButton(this.option, () => {
        EveryCigMovieContainer.playCigVideo(this.game, this.part, undefined, EveryCigDropdownScreenContainer.target)
    })

    disable = () => Buttons.undoSpriteButton(this.option)

    fadeIn = () => {
        this.game.input.enabled = true
    }

    fadeOut = () => {
        this.game.input.enabled = false
    }

}
